// TSS vite/03 §"Query keys convention".

export const tierKeys = {
    all:    ['tiers'],
    list:   (params) => ['tiers', 'list', params],
    detail: (id)     => ['tiers', 'detail', id],
    // How far a tier got, counted from the task listings. Under `tasks`, not
    // `tiers`: those are the rows it reads, so finishing a task invalidates it.
    progress: (tierId, state) => ['tasks', 'count', { tier_id: String(tierId), workflow_state: state ?? null }],
};
